import React from "react";
import { ReactComponent as SofaSvg } from "../svg/sofa.svg";

export default function SofaIcon({ size = 64, color = "#32363F", ...props }) {
  return <SofaSvg width={size} height={size} style={{ color }} {...props} />;
}
